var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.fatalError)?_c('FatalErrorMessage',{attrs:{"message":_vm.$store.state.fatalError}}):(!_vm.$store.state.apidata.isDataReady)?_c('Loading'):_c('nuxt')}
var staticRenderFns = []

export { render, staticRenderFns }